// extracted by mini-css-extract-plugin
module.exports = {"heading":"App_heading__2nYdz","profile":"App_profile__1XEJ4","workItems":"App_workItems__BefCK"};